exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".count[data-v-74dfe556]{font-size:14px;font-size:.875rem}", ""]);

